export default `float i,j,d=1.,a;
    vec3 Q;
    a=1.;
    d=p.y+1.;
    for(j=0.;j++<9.;)
      Q=(p+fract(sin(j)*1e4)*3.141592)*a,
      Q+=sin(Q)*2.,
      d+=sin(Q.x)*sin(Q.z)/a,
      a*=2.;
    return d*.15;
  }`